module.exports = __webpack_public_path__ + "img/lg.b50b5c56.png";